module.exports = {
	"home": {
		"p1": "En defensa del comercio leal,",
		"p2": "por una competencia equitativa"
	},
	"nosotros": {
		"title": "Nosotros",
		"consultig": {
			"title": "T-REZ Consulting",
			"p": " nace en 2018 como un nuevo despacho pero con una larga trayectoria por la experiencia de sus profesionales de  más  de  25  años  en  remedios  comerciales  y  solución  de controversias comerciales internacionales."
		},
		"trez1": {
			"title": "T-REZ",
			"p": " es el único despacho en México especializado en Remedios Comerciales   y   Solución   de   Controversias   Comerciales Internacionales;  y  en  particular,  especializado  en  la  defensa  de industrias nacionales contra prácticas desleales de comercio y en la  defensa  de  productores  nacionales  afectados  por  cuotas compensatorias injustificadas."
		},
		"trez2": {
			"title": "T-REZ",
			"p": " ofrece  servicios  legales  y  de  análisis  económico  en  el mismo  sitio,  y  nuestro  equipo  de  expertos  ofrece  servicios  en Remedios  Comerciales,  Solución  de  controversias,  Comercio Internacional  y  Análisis  Económicos  para  litigios  comerciales, altamente especializados  y únicos disponibles en el mercado."
		}
	},
	"socias": {
		"title": "Socias",
		"nombres": {
			"luz": "Luz Elena Reyes de la Torre",
			"nvo": "Nueva Socia",
			"itzia": "Itziar Esparza Mejía",
			"barbara": "Bárbara Casiopea Alvarado Ibarra"
		},
		"Luz": {
			"title": "Luz Elena Reyes de la Torre",
			"p1": "Socia Fundadora de T-REZ Consulting.",
			"p2": "Más de 25 años de experiencia en materia de Remedios Comerciales y controversias comerciales internacionales, principalmente sobre antidumping, subsidios y salvaguardas. ",
			"p3": "Fue Socia en SAI Derecho & Economía durante 20 años.",
			"p4": "Fue Directora General Adjunta de la Unidad de Prácticas Comerciales Internacionales de México en donde participó en el diseño del Sistema Antidumping Mexicano.",
			"p5": "Ha prestado servicios de asistencia técnica sobre la implementación y aplicación de los Acuerdos Antidumping, de Salvaguardas y sobre el Acuerdo de Subvenciones y Medidas Compensatorias a los gobiernos de América Latina.",
			"p6": "Es miembro del Consejo Consultivo de Prácticas Comerciales Internacionales.",
			"p7": "Es la Panelista de nacionalidad mexicana con más participaciones en paneles de solución de controversias comerciales en la OMC.",
			"p8": "En abril de 2016 fue nombrada Miembro del Grupo Permanente de Expertos de la OMC en materia de Subvenciones y Derechos Compensatorios por el periodo 2016-2021."
		},
		"Itziar": {
			"title": "Itziar Esparza Mejía",
			"p1": "Socia fundadora de T-REZ Consulting.",
			"p2": "Cuenta con más de una década de experiencia profesional en el ámbito de remedios comerciales (investigaciones antidumping, antisubsidios y salvaguardias) y resolución de disputas comerciales (arbitraje comercial y de inversión).",
			"p3": "Se ha especializado en representación de industrias nacionales  tales como alimentos animales, enseres domésticos, textiles, calzado, productos agrícolas, industria siderúrgica, incluidos procedimientos de revisión de resoluciones antidumping ante paneles binacionales constituidos bajo el capítulo XIX del Tratado de Libre Comercio de América del Norte y la Organización Mundial del Comercio, así como  juicios de nulidad ante Tribunal Federal de Justicia Administrativa.",
			"p4": "Antes de especializarse en Remedios Comerciales, ejerció durante más de seis años arbitraje comercial internacional bajo las reglas  CCI, LCIA, AAA, CAM, NAI, y de inversión al amparo del Capítulo XI del TLCAN, tanto asistiendo a tribunales arbitrales , así como abogada de parte.",
			"p5": "Asimismo, ha representado a empresas en procedimientos de inmunidad e investigaciones ante la autoridad de competencia, incluyendo respecto de mercados de telecomunicaciones y bienes de consumo."
		},
		"barbara": {
			"title": "Bárbara Casiopea Alvarado Ibarra",
			"p1": "Socia T-REZ Consulting.",
			"p2": "Cuenta con más de 20 años de experiencia en remedios comerciales. En el ámbito profesional, laboró  23 años en la Secretaría de Economía, en la que se desempeñó por 10 años como Directora General Adjunta de Jurídico de la Unidad de Prácticas Comerciales Internacionales, encargada de coordinar los procedimientos de investigación sobre dumping, subsidios y salvaguardias que tramita la autoridad mexicana, en investigaciones relativas a sectores como acero, textil, calzado, agropecuario, químico y otros de bienes manufacturados; participó  en más de 200 investigaciones. ",
			"p3": "Asimismo, tiene experiencia en el litigio nacional, pues se encargó por más de 20 años de resolver recursos administrativos de revocación promovidos en contra de los procedimientos en materia de prácticas desleales de comercio internacional, así como de fijar la estrategia de defensa en los juicios de amparo y contenciosos administrativos en dicha materia.",
			"p4": "Ha participado en la reforma de diversas normas en materia de comercio exterior, como son la Ley de Comercio Exterior y la Ley Aduanera y, en específico, coordinó las reformas más recientes al Reglamento de la Ley de Comercio Exterior.",
			"p5": "En el ámbito académico, ha impartido diversos cursos en materia de comercio exterior y capacitación sobre remedios comerciales, en diversos foros, tanto autoridades nacionales como extranjeras.",
			"p6": "Es licenciada en Derecho por la Facultad de Derecho de la Universidad Nacional Autónoma de México, Maestra en Derecho y Especialista en Derecho Constitucional, por la misma institución."
		}
	},
	"profesionales": {
		"main": "profesionales",
		"title": "Luz Elena Reyes de la Torre",
		"p1": "• Socia Fundadora de T-REZ Consulting.",
		"p2": "• Más de 25 años de experiencia en materia de Remedios Comerciales y controversias comerciales internacionales, principalmente sobre antidumping, subsidios y salvaguardas.",
		"p3": "• Fue Socia en SAI Derecho & Economía durante 20 años.",
		"p4": "• Fue Directora General Adjunta de la Unidad de Prácticas Comerciales Internacionales de México en donde participó en el diseño del Sistema Antidumping Mexicano.",
		"p5": "• Es la Panelista de nacionalidad mexicana con más participaciones en paneles de solución de controversias comerciales en la OMC.",
		"p6": "• Ha prestado servicios de asistencia técnica sobre la implementación y aplicación de los Acuerdos Antidumping, de Salvaguardas y sobre el Acuerdo de Subvenciones y Medidas Compensatorias a los gobiernos de América Latina.",
		"p7": "• Es miembro del Consejo Consultivo de Prácticas Comerciales Internacionales.",
		"p8": "• En abril de 2016 fue nombrada Miembro del Grupo Permanente de Expertos de la OMC en materia de Subvenciones y Derechos Compensatorios por el periodo 2016-2021.",
		"url": ""
	},
	"servicios": {
		"title": "Servicios",
		"t1": "Remedios Comerciales",
		"t2": "Disputas Comerciales",
		"t3": "Litigios Antidumping",
		"t4": "Economía-Litigios",
		"t5": "Monitoreo Estratégico",
		"t6": "Mx-USA Trade Planning",
		"p1": "T-REZ Consulting (T-REZ)  es  un  despacho  especializado  en  ”Remedios  Comerciales”  y solución de controversias internacionales. ",
		"p2": "Ofrecemos a productores nacionales nuestros conocimientos especializados en derecho y economía   internacional   para   asesorarlos   en   todas   las   etapas   de   los   diversos procedimientos  en  contra  de  las  prácticas  de  dumping,  o  en  contra  de  la  competencia internacional   desleal   por   subvenciones   y   apoyos   de   sus   gobiernos   para   ganar inequitativamente   mercados   locales,   así   como   en   la   solución   de   controversias comerciales internacionales.",
		"p3": "Nuestros servicios incluyen toda la amplia gama de servicios dentro de la especialidad de remedios  comerciales y de los mecanismos de solución de controversias internacionales:",
		"p4": "- Estudios  de  factibilidad  para  determinar  si  un  caso  de  presuntas  prácticas  desleales tiene  altas  probabilidades  de  éxito,  en  cuyo  caso  realiza  por  completo  los  estudios legales y económicos para integrar solicitudes de investigaciones  antidumping,  sobre subvenciones  o  de  medidas  de  salvaguarda  y  exámenes  quinquenales,  así  como procedimientos de elusión  de cuota y cobertura de producto;",
		"p5": "- Una vez presentadas las solicitudes formales ante la Secretaría de Economía, T-REZ se encarga  de  la  representación  legal  de  productores  nacionales  en  los  procedimientos legales ante dicha autoridad, o, en su caso, en juicios de nulidad. ",
		"p6": "- Asesoramos a Gobiernos o productores nacionales en paneles comerciales bilaterales o en paneles ante la OMC. ",
		"p7": "- Asesoramos  a  exportadores  al  mercado  de  los  EUA  en  denuncias  por  dumping  y realiza asesoría preventiva para una exitosa defensa ante posibles denuncias.",
		"p8": "En  suma,  el  equipo  de    T-REZ  cuenta  con  experiencia  de  20  años  en  la  defensa  de industrias   nacionales   frente   a   las   prácticas   desleales   de   comercio   internacional, ofreciendo un servicio integral que incluye, además de los servicios legales, servicios de asesoría   económica   y   de   análisis   de   la   situación   financiera   de   la   industria. Adicionalmente,  ofrecemos  asesoría  y  representación  de  partes  en  la  defensa  en  los mecanismos de solución de controversias comerciales, ya sea en TLCAN o en la OMC. "
	},
	"remedios": {
		"title": "Remedios Comerciales",
		"antidumping": {
			"h1": "Antidumping",
			"p1": "T-REZ se ha especializado en investigaciones promovidas por la industria nacional para defender una competencia leal y asegurar una cancha pareja.",
			"p2": "Frente a una competencia internacional, presumiblemente desleal, T-REZ realiza las investigaciones previas y estudios de factibilidad con la metodología de la legislación vigente nacional e internacional, para determinar si el caso tiene méritos y si tiene buenas probabilidades de éxito; es decir,  de que al final del procedimiento se impongan cuotas compensatorias a las importaciones desleales.",
			"p3": "T-REZ representa a la rama de producción nacional durante el procedimiento y elabora todos los estudios económicos  y escritos legales para la defensa de la industria.",
			"url": "/Servicios/RemediosC"
		},
		"subvenciones": {
			"h1": "Anti-subvenciones",
			"p1": "Una de las socias fundadoras es Miembros del Grupo Permanente de Expertos de la OMC en materia de Subvenciones y Derechos Compensatorios;  a nivel nacional representó a la industria mexicana en uno de los pocos casos en contra de subvenciones en México, específicamente en contra de subvenciones agropecuarias otorgadas por la Comisión Europea a  España e Italia.",
			"p2": "T-REZ analiza la existencia de subvenciones, así como si estas son compensables y, en su caso, elabora los documentos económicos y legales para defender y representar a la industria nacional en el procedimiento.",
			"url": "/Servicios/RemediosC"
		},
		"salvaguardias": {
			"h1": "Salvaguardias",
			"p1": "Cuando existen incrementos significativos de las importaciones que causan o amenazan causar un daño grave a la industria mexicana, a pesar de que no exista práctica desleal, T-REZ realiza los estudios y argumentos necesarios para solicitar medidas de salvaguarda en forma de incrementos temporales de aranceles o establecimiento de cupos para que la industria nacional pueda realizar los programas de ajuste necesarios para mejor sus niveles competitivos.",
			"p2": "Una de las socias fundadoras dirigió los estudios y representó al sector avícola nacional en la única salvaguarda bilateral al amparo del TLCAN realizada en México, que culminó con una exitosa negociación entre los sectores de los dos países y con medidas que se aplicaron durante 5 años.",
			"url": "/Servicios/RemediosC"
		},
		"examenes": {
			"h1": "Exámenes de vigencia",
			"p1": "Previo a la conclusión de los 5 años de vigencia de las cuotas compensatorias, existe un procedimiento que permite, en caso de cumplirse con los supuestos previstos le ley, prorrogar dichas cuotas.",
			"p2": "Las socias fundadoras han representado exitosamente a diversas industrias nacionales en los exámenes quinquenales.",
			"url": "/Servicios/RemediosC"
		},
		"reviciones": {
			"h1": "Revisiones anuales",
			"p1": "T-REZ representa a la industria nacional en los casos en los que un exportador solicita que se revisen sus márgenes de dumping en un periodo más reciente al investigado en el procedimiento original, para lograr que se reduzcan o eliminen las cuotas compensatorias impuestas; por lo que es importante la industria nacional participe y se asegure que se siguen los procedimientos adecuados y se aplican la metodologías pertinentes con el fin de que no se eliminen o reduzcan injustificadamente las cuotas compensatorias. T-REZ se encarga de ésta defensa en nombre de la industria nacional.",
			"url": "/Servicios/RemediosC"
		},
		"elusion": {
			"h1": "Anti - elusión ",
			"p1": "En muchas ocasiones los importadores o exportadores tratan de evitar las cuotas compensatorias impuestas diferenciando ligeramente el producto  que fue objeto de investigación, o importándolo en partes cuando esto es posible. T-REZ representa a los productores nacionales en procedimientos anti-elusión de cuotas para que la Secretaría de Economía extienda las cuotas a dichos productos diferenciados mínimamente o que se importan en partes para evitar pagar las cuotas aplicables.",
			"url": "/Servicios/RemediosC"
		},
		"cobertura": {
			"h1": "Cobertura de producto",
			"p1": "Cuando algún importador o exportador de mercancía sujeta a cuotas compensatorias inicia un procedimiento solicitando a la autoridad antidumping que se excluyan ciertos productos de la aplicación de la misma, T-REZ asesora a los productores nacionales para asegurar que las autoridades correspondientes no excluyan de la aplicación de la cuota compensatoria algún producto que deba de estar considerado de conformidad con el procedimiento y los hechos que dieron lugar a la aplicación de cuotas.",
			"url": "/Servicios/RemediosC"
		}
	},
	"disputas": {
		"title": "Disputas comerciales",
		"panelesTLC": {
			"h1": "Paneles TLC -TMEC",
			"p1": "T-REZ  ofrece el servicio de representar a las partes en Paneles binacionales T-MEC (antes TLCAN).",
			"url": "/DisputasComerciales"
		},
		"panelesOMC": {
			"h1": "Paneles OMC",
			"p1": "T-REZ también ofrece sus servicios profesionales para asesorar a gobiernos en la defensa de sus resoluciones en procedimientos de Grupos Especiales en el marco de órgano de solución de controversias de la OMC. Los servicios incluyen la redacción de sus comparecencias y  soporte jurídico con precedentes relevantes para la solución de la controversia.",
			"url": "/DisputasComerciales"
		}
	},
	"litigios": {
		"title": "Litigios Antidumping",
		"recursos": {
			"h1": "Recursos de revocación",
			"p1": "T-REZ representa a empresas en recursos de revocación ante la Secretaría de Economía contra resoluciones finales emitidas en investigaciones antidumping, exámenes de vigencia o cualquier otro procedimiento de remedios comerciales bajo la Ley de Comercio Exterior.",
			"url": "/LitigiosAntidumping/"
		},
		"juicios": {
			"h1": "Juicios de nulidad",
			"p1": "T-REZ representa a empresas en juicios de nulidad respecto de resoluciones finales antidumping ante Tribunal Federal de Justicia Administrativa.",
			"url": "/LitigiosAntidumping/"
		},
		"amparos": {
			"h1": "Amparos",
			"p1": "T-REZ colabora junto con despachos amparistas en juicios de amparo relacionados con resoluciones finales emitidas por la Secretaría de Economía en materia de remedios comerciales.",
			"url": "/LitigiosAntidumping/"
		},
		"peritajes": {
			"h1": "Peritajes",
			"p1": "T-REZ ofrece servicio de peritajes jurídicos, económicos, que se precisen en procedimiento de remedios comerciales o juicios de nulidad.",
			"url": "/LitigiosAntidumping/"
		}
	},
	"economia": {
		"title": "Economía-Litigios",
		"menu": {
			"p1": "Análisis de importaciones",
			"p2": "Márgenes de dumping",
			"p3": "Daño a la industria",
			"p4": "Cálculo de Subvenciones",
			"p5": "Verificaciones “in situ”",
			"url": "/EconomiaLitigios/"
		},
		"analisis": {
			"h1": "1. Análisis de importaciones",
			"p1": "En todos los procedimientos sobre remedios comerciales es necesario un análisis específico y especializado de las operaciones de comercio exterior;  T-REZ ofrece la elaboración de análisis de las importaciones por producto específico, por país, por importador e identifica patrones de precios para apoyar las investigaciones o procedimientos sobre remedios comerciales, o para identificar tendencias de precios y productos de los principales competidores internacionales de la industria nacional.",
			"url": "/EconomiaLitigios/"
		},
		"margenes": {
			"h1": "",
			"p1": "En diversos  casos  T-REZ  podría ofrecer realizar el análisis de precios de los principales productos exportados a México tanto en sus mercados de origen como en sus mercados de exportación para calcular márgenes de dumping que apoyen una investigación en contra de prácticas desleales de comercio internacional.",
			"url": "/EconomiaLitigios/"
		},
		"dano": {
			"h1": "3. Daño a la industria",
			"p1": "T-REZ cuenta con el personal especializado en realizar los estudios necesarios para determinar la existencia o no de daño o amenaza de daño causados a la industria nacional por la competencia desleal (dumping o subvenciones) de conformidad con la metodología aceptada para tales efectos a nivel nacional o internacional. ",
			"url": "/EconomiaLitigios/"
		},
		"calculo": {
			"h1": "4. Cálculo de Subvenciones",
			"p1": "Cuando una industria nacional presume que  un competidor internacional lo hace en condiciones ventajosas derivadas de los apoyos que le otorga su gobierno, es necesario llevar a cabo un estudio que determine si éstos apoyos existen y si efectivamente afectan los precios de exportación a un país;  T-REZ realiza dichos estudios especializados con la metodología admitida por la Organización Mundial de Comercio y, en su caso, puede asesorar en la solicitud de su eliminación mediante los procedimientos establecidos en las legislaciones nacional e internacional.",
			"url": "/EconomiaLitigios/"
		},
		"verificacion": {
			"h1": "5. Verificaciones “in situ”",
			"p1": "Cuando las empresas nacionales exportadoras son notificadas por las autoridades antidumping competentes, principalmente de los EUA, sobre la realización de una visita de verificación en sus instalaciones, con respecto a la información aportada en un procedimiento antidumping, T-REZ ofrece  sus servicios profesionales especializados en este evento, que implica aspectos económicos, financieros, contables y legales. Capacita a los equipos internos de las compañías, en coordinación con los despachos de abogados estadounidenses, y asesora en la preparación previa de toda la documentación que será verificada por la autoridad.",
			"url": "/EconomiaLitigios/"
		}
	},
	"monitoreos": {
		"title": "Monitoreos Estrategicos",
		"menu": {
			"p1": "Monitoreo de precios",
			"p2": "Alertas Dumping",
			"url": "/MonitoreoEstrategico/"
		},
		"monitoreo": {
			"h1": "Monitoreo de precios",
			"p1": "T-REZ ofrece el servicio de Monitoreo Comercial Estratégico, este consiste en realizar un análisis bimestral o trimestral sobre el comportamiento de los precios y los volúmenes importados de productos específicos de los principales competidores de la industria nacional en el mercado mexicano.",
			"p2": "Este monitoreo permite anticipar posibles situaciones en la competencia internacional que puedan afectar a  la industria nacional, o simplemente para conocer el posicionamiento de competidores internacionales en el mercado local.",
			"url": "/MonitoreoEstrategico/"
		},
		"alertas": {
			"h1": "Alertas Anti-Dumping",
			"p1": "El servicio de T-REZ sobre “Alertas dumping” se basa en un modelo que considera diversos parámetros que se obtienen a partir del análisis de los indicadores económicos más relevantes del mercado bajo análisis para determinar en forma anticipada o preventiva la posible ocurrencia de prácticas de comercio internacional en un mercado específico.",
			"url": "/MonitoreoEstrategico/"
		}
	},
	"tradepla": {
		"title": "MX-USA Trade Planning",
		"menu": {
			"p1": "Riesgo antidumping en USA",
			"p2": "Cuestionarios DOC y ITC",
			"p3": "Verificaciones in situ USDOC",
			"url": "/Mx-USA-TradePlanning/"
		},
		"riesgo": {
			"h1": "1. Riesgo antidumping en USA",
			"p1": "Las empresas con presencia importante de sus exportaciones en el mercado norteamericano,  tienen el riesgo de que el gobierno de los EUA inicie investigaciones antidumping o en contra de subvenciones, que pueden concluir en la aplicación de derechos antidumping en sus exportaciones a ese país afectando con ello su acceso a dicho mercado.",
			"p2": "T-REZ ofrece un servicio especializado que permite analizar, con la metodología aplicable en los EUA, las condiciones en las que se realizan las exportaciones de una empresa nacional a los EUA y si éstas constituyen un riesgo para ser objeto de investigaciones en su contra por el gobierno de los EUA. Es un servicio preventivo y propone cambios en sus políticas de precios y ventas para minimizar el riesgo de casos antidumping en los Estados Unidos de América.",
			"url": "/Mx-USA-TradePlanning/"
		},
		"cuestionarios": {
			"h1": "2. Cuestionarios DOC y ITC",
			"p1": "En caso de que un exportador sea investigado por el gobierno de los EUA por supuestas prácticas de dumping T-REZ ofrece el servicio de apoyo a la empresa exportadora para el adecuado llenado de los cuestionarios antidumping solicitados por el Departamento de Comercio de los EUA, en coordinación con los Abogados estadounidenses."
		},
		"verificaciones": {
			"h1": "Verificaciones in situ USDOC",
			"p1": "T-REZ ofrece  sus servicios profesionales especializados en este evento que implica aspectos económicos, financieros, contables y legales. Capacita a los equipos internos de las compañías, en coordinación con los despachos de abogados estadounidenses, y asesora en la preparación previa de toda la documentación que será verificada por el Departamento de Comercio de los EUA (USDOC).",
			"url": "/Mx-USA-TradePlanning/"
		}
	},
	"industrias": {
		"title": "Industrias",
		"menu": {
			"p1": "Agropecuario",
			"p2": "Manufacturero",
			"p3": "Consumo Final"
		},
		"agropecuario": {
			"h1": "1. Agropecuario",
			"p1": "Las socias fundadoras han representado exitosamente a la Industria Avícola Nacional en diversos procedimientos sobre remedios comerciales y en litigios sobre controversias comerciales internacionales. Entre ellos en la primera y única medida de salvaguardia que se ha aplicado en México, sobre la pierna y muslo de pollo de E.U.A, en un caso en contra de las importaciones en condiciones de dumping de los EUA, y defendiendo sus intereses en un panel binacional constituido bajo el capítulo XIX del TLCAN.",
			"p2": "También representó a los productores de aceitunas y aceite de oliva en contra de las subvenciones otorgadas por Comisión Europea a exportadores españoles e italianos ."
		},
		"manufacturero": {
			"h1": "Manufacturero",
			"p1": "T-REZ también tiene una amplia experiencia en diversos sectores clave como son los del aluminio, acero inoxidable, tubo de cobre, textiles, Ferroaleaciones, etc"
		},
		"consumo": {
			"h1": "3. Consumo Final",
			"p1": "La experiencia de T-REZ en industrias de productos de consumo final es amplia, a los que ha representado o elaborado estudios para apoyar procedimientos sobre remedios comerciales; destacan artículos de cocina; licuadoras, calzado, prendas de vestir, globos metálicos. ……"
		}
	},
	"presencia": {
		"title": "V. Presencia",
		"menu": {
			"p1": "• Redes sociales",
			"p2": "• Artículos",
			"p3": "• Noticias"
		},
		"redes": {
			"h1": "• Redes sociales",
			"p1": ""
		},
		"articulos": {
			"h1": "• Artículos",
			"p1": ""
		},
		"noticias": {
			"h1": "• Noticias",
			"p1": ""
		}
	},
	"recursos": {
		"title": "Recursos",
		"menu": {
			"p1": "Legislación OMC",
			"p2": "Antidumping en México",
			"p3": "Antidumping en EUA",
			"p4": "Estadísticas Comerciales",
			"p5": "Otros Sitios Relevantes"
		},
		"legislacion": {
			"h1": "1. Legislación OMC",
			"p1": "Acuerdo Antidumping",
			"p2": "Acuerdo de Salvaguardias",
			"p3": "Acuerdo sobre Subvenciones y Medidas Compensatorias",
			"p4": "Solución de diferencias  OMC"
		},
		"antidumping": {
			"h1": "2. Antidumping en México",
			"p1": "Ley de Comercio Exterior",
			"p2": "Reglamento de la Ley de Comercio Exterior",
			"p3": "Diario Oficial de la Federación ",
			"p4": "Unidad de Prácticas Comerciales Internacionales (UPCI)",
			"p5": "Consejo Consultivo de Prácticas Comerciales Internacionales (CCPCI)"
		},
		"antidumpigEUA": {
			"h1": "3. Antidumping en EUA",
			"p1": "Departamento de Comercio de los EUA (USDOC)",
			"p2": "International Trade Comission (USITC)",
			"p3": "Federal Register"
		},
		"estadistica": {
			"h1": "4. Estadísticas Comerciales",
			"p1": "Tarifa de la Ley de los Impuestos Generales de Importación y Exportación (TIGIE)",
			"p2": "Sistema de Información Arancelaria vía Internet (SIAVI)",
			"p3": "International Trade Center (ITC)"
		},
		"otros": {
			"h1": "5. Otros Sitios Relevantes",
			"p1": "Correlación TIGI y y el Sistema de Clasificación Industrial de América del Norte (SCIAN)",
			"p2": "World Trade Law"
		}
	},
	"contacto": {
		"title": "Contacto",
		"direccion": "Torre Siglum Insurgentes Sur #1898,Piso 14 Despacho 1421 Col. Florida, 01020 CDMX, México.",
		"oficina": "Piso 14 Despacho 1421 Col. Florida",
		"cp": "01020 CDMX, México.",
		"numero": "(55)9171-1047/52",
		"email": "trez@t-rezconsulting.com"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/Lang/Esp.json
// module id = 19
// module chunks = 0